var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2632 20C18.4586 20 18.646 19.9267 18.7842 19.7962C18.9224 19.6658 19 19.4888 19 19.3043V8.15513C18.9996 7.05299 18.5356 5.99612 17.71 5.21693C16.8844 4.43773 15.7648 4 14.5974 4H5.73684C5.54142 4 5.354 4.07329 5.21582 4.20375C5.07763 4.33421 5 4.51115 5 4.69565V19.3043C5 19.4888 5.07763 19.6658 5.21582 19.7962C5.354 19.9267 5.54142 20 5.73684 20H18.2632Z",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3154 4.05493V6.78258C15.3154 6.96708 15.3931 7.14402 15.5312 7.27448C15.6694 7.40494 15.8568 7.47824 16.0523 7.47824H18.9407",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40584 14.0869C9.40584 14.3637 9.28939 14.6291 9.08211 14.8248C8.87484 15.0205 8.59371 15.1304 8.30058 15.1304H7.19531V13.0435H8.30058C8.59371 13.0435 8.87484 13.1534 9.08211 13.3491C9.28939 13.5448 9.40584 13.8102 9.40584 14.0869Z",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19531 17.2168V15.1299",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8789 13.0435C11.4652 13.0435 12.0274 13.2633 12.442 13.6547C12.8565 14.0461 13.0894 14.5769 13.0894 15.1304C13.0894 15.6839 12.8565 16.2147 12.442 16.6061C12.0274 16.9975 11.4652 17.2174 10.8789 17.2174V13.0435Z",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5635 17.2174V13.7391C14.5635 13.5546 14.6411 13.3777 14.7793 13.2472C14.9175 13.1167 15.1049 13.0435 15.3003 13.0435H16.774",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5635 15.1299H16.0372",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPdf);
export default __webpack_public_path__ + "static/media/form-pdf.9d183dc545be892d27c7d800a15cef86.svg";
export { ForwardRef as ReactComponent };